"use client";

import * as React from "react";
import { Quote } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DrivenByExcellence() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="222839" id="why-strategy-matters" ref={sectionRef} className="relative overflow-hidden bg-background text-foreground py-32 md:py-48 flex items-center justify-center min-h-[80vh]">
      {}
      <div className={`absolute inset-0 flex items-center justify-center pointer-events-none transition-opacity duration-1000 ease-in-out ${isSectionVisible ? "opacity-10 dark:opacity-[0.05]" : "opacity-0"}`} aria-hidden="true">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661389/img/marketing_funnel_blueprint.png" alt="Strategic Marketing Funnel Blueprint" className="w-[120vw] md:w-[80vw] max-w-[1000px] object-contain rotate-[-5deg] scale-110 grayscale invert dark:invert-0" />
      </div>

      {}
      <div className="relative z-10 container mx-auto px-6 md:px-12 text-center max-w-4xl">
        <div ref={textRef} className={`flex flex-col items-center transition-all duration-1000 ease-out transform ${isSectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <Quote className="w-12 h-12 md:w-16 md:h-16 text-primary/30 mb-8" strokeWidth={1} />
          
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-default font-bold text-foreground leading-tight md:leading-tight mb-10 tracking-tighter">
            "Strategy is not a luxury; it is the architectural blueprint that separates market leaders from the noise."
          </h2>
          
          <p className="text-lg md:text-xl text-muted-foreground mb-14 max-w-2xl mx-auto leading-relaxed font-mono">
            At Benchmark Media Consulting, we engineer growth through data-driven intelligence. Our methodology transforms abstract brand goals into measurable market dominance using precision-targeted advertising and elite creative execution.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="rounded-sm px-8 h-12 text-base bg-primary hover:bg-primary/90 shadow-lg shadow-primary/20">
              <Link to="/MethodPage">
                Our Methodology
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="rounded-sm px-8 h-12 text-base border-primary/50 hover:bg-primary/5">
              <Link to="/SolutionsPage">
                View Solutions
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}